(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lucent-frame-alignment"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const selector = '.spf-product-card__image-wrapper img.spf-product-card__image, .product-block .image-inner img.rimage__image, .lucent-light-collection__image img';
  const edgeNoiseImages = new Set([
    "the-bolt-kids-black-red-rectangular-acetate-glasses.jpg",
    "IMG_2853.jpg",
    "IMG_2852.jpg",
    "the-scout-kids-red-black-rectangular-acetate-glasses.jpg",
    "IMG_2823.jpg",
    "IMG_2824.jpg",
    "IMG_2826.jpg",
    "the-scout-kids-red-black-rectangular-acetate.jpg",
    "IMG_2818_bc2a3794-9883-4936-a242-038f321416f9.jpg",
    "the-professor-kids-gold-multicolor-round-acetate-glasses.jpg",
    "IMG_2817_b8254b83-27c2-46c8-b451-928578a2d2ef.jpg",
    "the-sprocket-kids-tortoise-round-acetate-glasses-with-strap.jpg",
    "IMG_2817.jpg",
    "IMG_2757.jpg",
    "IMG_2786_9cf3c7f0-a3d1-4621-975d-150f57cc4536.jpg",
    "IMG_2887.jpg",
    "the-racer-kids-red-white-rectangular-glasses.jpg",
    "HarveBenard723-DemiAmberFront.png",
    "HarveBenard723_DemiAmber.png"
]);
  const states = new WeakMap();
  const cache = new Map();
  const nearby = new WeakSet();
  const pending = new Set();
  let scheduled = false;

  function measure(source) {
    const canvas = document.createElement('canvas');
    const ratio = source.naturalWidth / source.naturalHeight;
    const width = canvas.width = Math.round(256 * Math.min(1, ratio));
    const height = canvas.height = Math.round(256 * Math.min(1, 1 / ratio));
    if (width < 32 || height < 32) return null;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return null;
    context.fillStyle = '#fff';
    context.fillRect(0, 0, width, height);
    context.drawImage(source, 0, 0, width, height);
    const pixels = context.getImageData(0, 0, width, height).data;
    const rows = new Uint16Array(height);
    const columns = new Uint16Array(width);
    const imageName = new URL(source.currentSrc || source.src, document.baseURI).pathname.split('/').pop().replace(/_\d+x\d*(?=\.[^.]+$)/, '');
    const pixelThreshold = imageName === 'The_Spark_durable_kids_blue_rectangular_glasses_front_view_with_flexible_temple_tips.jpg' ? 225 : 242;
    let border = 0;
    let darkBorder = 0;
    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const index = (y * width + x) * 4;
        const dark = Math.min(pixels[index], pixels[index + 1], pixels[index + 2]) < pixelThreshold;
        if (x < 3 || x >= width - 3 || y < 3 || y >= height - 3) {
          border += 1;
          if (dark) darkBorder += 1;
        }
        if (dark) {
          rows[y] += 1;
          columns[x] += 1;
        }
      }
    }
    if (darkBorder / border > 0.02) return null;
    const minimumRowPixels = edgeNoiseImages.has(imageName) ? 6 : 2;
    let left = columns.findIndex(count => count >= 2);
    let top = rows.findIndex(count => count >= minimumRowPixels);
    if (left < 0 || top < 0) return null;
    let right = width - 1;
    let bottom = height - 1;
    while (right > left && columns[right] < 2) right -= 1;
    while (bottom > top && rows[bottom] < minimumRowPixels) bottom -= 1;
    left = Math.max(0, left - 2);
    top = Math.max(0, top - 2);
    right = Math.min(width, right + 3);
    bottom = Math.min(height, bottom + 3);
    const boxWidth = (right - left) / width;
    const boxHeight = (bottom - top) / height;
    if (boxWidth < 0.18 || boxWidth > 0.97 || boxHeight < 0.035 || boxHeight > 0.8 || (right - left) / (bottom - top) < 1.3) return null;
    return { x: (left + right) / (2 * width), y: (top + bottom) / (2 * height), width: boxWidth, height: boxHeight, ratio };
  }

  function clear(image) {
    image.removeAttribute('data-lucent-frame-aligned');
    ['--lucent-frame-x', '--lucent-frame-y', '--lucent-frame-scale'].forEach(name => image.style.removeProperty(name));
  }

  function apply(image, bounds) {
    const width = image.clientWidth;
    const height = image.clientHeight;
    if (!width || !height || !bounds) return;
    const fittedWidth = Math.min(1, bounds.ratio * height / width);
    const fittedHeight = Math.min(1, width / (bounds.ratio * height));
    const scale = Math.min(2.5, 0.76 / (bounds.width * fittedWidth), 0.56 / (bounds.height * fittedHeight));
    image.style.setProperty('--lucent-frame-scale', scale.toFixed(5));
    image.style.setProperty('--lucent-frame-x', `${((0.5 - bounds.x) * fittedWidth * scale * 100).toFixed(5)}%`);
    image.style.setProperty('--lucent-frame-y', `${((0.5 - bounds.y) * fittedHeight * scale * 100).toFixed(5)}%`);
    image.setAttribute('data-lucent-frame-aligned', '');
  }

  async function analyze(image) {
    const state = states.get(image);
    const source = image.currentSrc || image.src;
    if (!state || !nearby.has(image) || !image.isConnected || !image.complete || image.naturalWidth < 32 || !/^https?:/.test(source)) return;
    if (state.source === source) {
      if (state.bounds) apply(image, state.bounds);
      return;
    }
    state.source = source;
    state.bounds = null;
    clear(image);
    let result = cache.get(source);
    if (!cache.has(source)) {
      result = (async () => {
        try {
          return measure(image);
        } catch {
          try {
            const copy = new Image();
            copy.crossOrigin = 'anonymous';
            copy.decoding = 'async';
            copy.src = source;
            await copy.decode();
            return measure(copy);
          } catch {
            return null;
          }
        }
      })();
      if (cache.size >= 300) cache.delete(cache.keys().next().value);
      cache.set(source, result);
    }
    const bounds = await result;
    if (!image.isConnected || state.source !== source || (image.currentSrc || image.src) !== source) return;
    state.bounds = bounds;
    if (bounds) apply(image, bounds);
  }

  function enqueue(image) {
    pending.add(image);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const batch = Array.from(pending);
      pending.clear();
      batch.forEach(image => { void analyze(image); });
    });
  }

  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        nearby.add(entry.target);
        enqueue(entry.target);
      } else {
        nearby.delete(entry.target);
      }
    });
  }, { rootMargin: '300px' });

  const sizes = new ResizeObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (state?.bounds && nearby.has(entry.target)) apply(entry.target, state.bounds);
    });
  });

  function attach(image) {
    if (states.has(image)) return;
    states.set(image, { source: '', bounds: null });
    image.addEventListener('load', () => enqueue(image));
    visibility.observe(image);
    sizes.observe(image);
  }

  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(selector)) attach(root);
    root.querySelectorAll(selector).forEach(attach);
  }

  function detach(root) {
    if (!(root instanceof Element) || root.isConnected) return;
    const images = root.matches(selector) ? [root, ...root.querySelectorAll(selector)] : root.querySelectorAll(selector);
    images.forEach(image => {
      visibility.unobserve(image);
      sizes.unobserve(image);
      states.delete(image);
      nearby.delete(image);
      pending.delete(image);
    });
  }

  scan(document.body);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') {
        record.addedNodes.forEach(scan);
        record.removedNodes.forEach(detach);
      } else if (record.target instanceof HTMLImageElement && record.target.matches(selector)) {
        attach(record.target);
        enqueue(record.target);
      }
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lucent-lens-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucent-lens-availability')) {
    customElements.define('lucent-lens-availability', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.dataset.available === 'true') return;
        this.ready = true;
        this.normalize = value => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
        this.lensName = this.normalize(this.dataset.lensName);
        this.disabledButtons = new Map();
        this.findOption = target => {
          const card = target instanceof Element ? target.closest('.lool-option') : null;
          const title = card?.querySelector('.lool-product-title');
          return title && this.normalize(title.textContent) === this.lensName ? card : null;
        };
        this.hasSelection = panel => Array.from(panel.querySelectorAll('div')).some(node =>
          !node.children.length && !node.closest('.lool-option') &&
          this.normalize(node.textContent) === this.lensName
        );
        this.isForwardButton = button => button && !button.matches('.lool-close-btn, .lool-back-btn');
        this.block = event => {
          if ((event.type === 'keydown' || event.type === 'keyup') &&
              !['Enter', ' ', 'Spacebar'].includes(event.key)) return;
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;
          const card = this.findOption(target);
          const panel = target.closest('.lool-dialog-panel');
          const button = target.closest('button');
          if (!card && !(panel && this.isForwardButton(button) && this.hasSelection(panel))) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (event.type === 'click' || event.type === 'keydown') this.showMessage(panel);
        };
        this.scan = () => {
          document.querySelectorAll('.lool-option .lool-product-title').forEach(title => {
            const card = this.findOption(title);
            if (!card) return;
            card.setAttribute('data-lucent-unavailable', '');
            card.setAttribute('aria-disabled', 'true');
            card.setAttribute('role', 'radio');
            card.setAttribute('aria-checked', 'false');
            card.setAttribute('tabindex', '0');
            card.setAttribute('aria-label', `${this.dataset.lensName} — ${this.dataset.label}`);
            if (!card.querySelector('.lucent-lens-stock-label')) {
              const label = document.createElement('span');
              label.className = 'lucent-lens-stock-label';
              label.textContent = this.dataset.label;
              title.insertAdjacentElement('afterend', label);
            }
          });
          document.querySelectorAll('.lool-dialog-panel').forEach(panel => {
            if (!this.hasSelection(panel)) {
              this.disabledButtons.forEach((original, button) => {
                if (!panel.contains(button)) return;
                button.disabled = original.disabled;
                if (original.aria === null) button.removeAttribute('aria-disabled');
                else button.setAttribute('aria-disabled', original.aria);
                this.disabledButtons.delete(button);
              });
              if (!panel.querySelector('.lool-option')) panel.querySelector('.lucent-lens-stock-message')?.remove();
              return;
            }
            panel.querySelectorAll('button').forEach(button => {
              if (this.isForwardButton(button)) {
                if (!this.disabledButtons.has(button)) {
                  this.disabledButtons.set(button, {disabled: button.disabled, aria: button.getAttribute('aria-disabled')});
                }
                button.disabled = true;
                button.setAttribute('aria-disabled', 'true');
              }
            });
            this.showMessage(panel);
          });
        };
        this.events = ['pointerdown', 'mousedown', 'touchstart', 'click', 'keydown', 'keyup'];
        this.events.forEach(type => document.addEventListener(type, this.block, {capture: true, passive: false}));
        this.observer = new MutationObserver(this.scan);
        this.observer.observe(document.body, {childList: true, subtree: true, characterData: true});
        this.scan();
      }
      showMessage(panel) {
        if (!panel || panel.querySelector('.lucent-lens-stock-message')) return;
        const message = document.createElement('p');
        message.className = 'lucent-lens-stock-message';
        message.setAttribute('role', 'status');
        message.textContent = this.dataset.message;
        panel.prepend(message);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.forEach(type => document.removeEventListener(type, this.block, true));
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lucent-lens-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucent-lens-comparison')) {
    customElements.define('lucent-lens-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.update) return;
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: this.dataset.currency});
        this.update = (event, data) => {
          const variant = data?.variant;
          this.querySelectorAll('[data-lens]').forEach(row => {
            const total = variant?.available ? variant.price + Number(row.dataset.lens) : NaN;
            row.querySelector('[data-total]').textContent = Number.isSafeInteger(total) ? money.format(total / 100) : '—';
          });
        };
        if (window.jQuery) jQuery(window).on('cc-variant-updated', this.update);
      }
      disconnectedCallback() {
        if (window.jQuery && this.update) jQuery(window).off('cc-variant-updated', this.update);
        this.update = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lucent-lens-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucent-lens-help')) {
    customElements.define('lucent-lens-help', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = new WeakSet();
        this.sequence = 0;
        this.abort = new AbortController();
        this.scan = () => {
          document.querySelectorAll('.lool-dialog-panel').forEach(panel => {
            panel.querySelectorAll('.lool-variant-desc-review > div, .lool-variant-desc-left > div').forEach(description => {
              if (/^Non-prescription blue light lenses\. Frame sold separately\.$/.test(description.textContent.trim())) {
                description.textContent = this.dataset.blueSummary;
              }
            });
            const titles = [...panel.querySelectorAll('.lool-option-title')];
            titles.forEach(title => {
              if (!/blue[ -]?light/i.test(title.childNodes[0]?.textContent || title.textContent)) return;
              const card = title.closest('.lool-option');
              if (!card) return;
              this.enhance(card, title, 'blue');
              const description = card.querySelector('.lool-product-desc');
              if (description && description.textContent !== this.dataset.blueSummary) description.textContent = this.dataset.blueSummary;
            });
          });
          if (this.active && !this.active.card.isConnected) this.hide();
        };
        this.onAction = event => {
          const target = event.target instanceof Element ? event.target : null;
          const button = target?.closest('.lucent-lens-info-button');
          if (event.type === 'keydown' && event.key === 'Escape' && this.active) {
            event.preventDefault(); event.stopImmediatePropagation(); this.hide(); return;
          }
          if (!button) {
            if (event.type === 'click' && this.active && !this.active.tooltip.contains(target)) this.hide();
            return;
          }
          event.stopImmediatePropagation();
          if (event.type === 'click' || (event.type === 'keydown' && ['Enter', ' '].includes(event.key))) {
            event.preventDefault();
            const card = button.closest('.lool-option');
            if (this.active?.button === button && this.active.pinned) this.hide();
            else this.show(card, button, true);
          } else if (event.type === 'keyup' && ['Enter', ' '].includes(event.key)) event.preventDefault();
        };
        ['pointerdown', 'mousedown', 'touchstart', 'click', 'keydown', 'keyup'].forEach(type =>
          document.addEventListener(type, this.onAction, {capture: true, signal: this.abort.signal})
        );
        window.addEventListener('resize', () => this.hide(), {signal: this.abort.signal});
        this.observer = new MutationObserver(this.scan);
        this.observer.observe(document.body, {childList: true, subtree: true});
        this.scan();
      }
      enhance(card, heading, kind) {
        if (this.cards.has(card)) return;
        this.cards.add(card);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'lucent-lens-info-button'; button.textContent = 'i';
        button.setAttribute('aria-label', this.dataset[kind + 'Label']);
        button.setAttribute('aria-expanded', 'false');
        button.dataset.copy = this.dataset[kind + 'Copy'];
        const tooltip = document.createElement('div');
        tooltip.id = 'lucent-lens-tooltip-' + (++this.sequence);
        tooltip.className = 'lucent-lens-tooltip'; tooltip.setAttribute('role', 'tooltip'); tooltip.setAttribute('popover', 'manual');
        tooltip.textContent = button.dataset.copy;
        button.setAttribute('aria-describedby', tooltip.id); button.setAttribute('aria-controls', tooltip.id);
        heading.append(button);
        card.append(tooltip);
        card.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.show(card, button); });
        card.addEventListener('pointerleave', () => this.deferHide());
        card.addEventListener('focusin', () => this.show(card, button));
        card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget)) this.hide(); });
        tooltip.addEventListener('pointerenter', () => clearTimeout(this.hideTimer));
        tooltip.addEventListener('pointerleave', () => this.deferHide());
      }
      show(card, button, pinned = false) {
        clearTimeout(this.hideTimer);
        if (this.active?.button === button) { this.active.pinned ||= pinned; return; }
        this.hide();
        const tooltip = card.querySelector('.lucent-lens-tooltip');
        if (!tooltip || !tooltip.showPopover) return;
        tooltip.showPopover();
        const anchor = card.getBoundingClientRect();
        const control = button.getBoundingClientRect();
        const bounds = tooltip.getBoundingClientRect();
        const left = Math.max(16, Math.min(control.right - bounds.width, innerWidth - bounds.width - 16));
        const below = anchor.bottom + 10;
        const top = below + bounds.height < innerHeight - 16 ? below : Math.max(16, anchor.top - bounds.height - 10);
        tooltip.style.left = left + 'px'; tooltip.style.top = top + 'px';
        button.setAttribute('aria-expanded', 'true');
        this.active = {card, button, tooltip, pinned};
      }
      deferHide() {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
          if (!this.active || this.active.pinned || this.active.card.contains(document.activeElement)) return;
          this.hide();
        }, 180);
      }
      hide() {
        clearTimeout(this.hideTimer);
        if (!this.active) return;
        this.active.tooltip.hidePopover?.();
        this.active.button.setAttribute('aria-expanded', 'false');
        this.active = null;
      }
      disconnectedCallback() {
        this.observer?.disconnect(); this.abort?.abort(); this.hide(); this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lucent-offers-ticker-core"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucent-offers-ticker')) {
    customElements.define('lucent-offers-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.lucent-ticker__track');
        this.group = this.querySelector('.lucent-ticker__group');
        this.viewport = this.querySelector('.lucent-ticker__viewport');
        this.button = this.querySelector('.lucent-ticker__pause');
        this.offers = this.querySelector('details');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        this.userPaused = false;
        try { this.userPaused = sessionStorage.getItem('lucent-offers-paused') === 'true'; } catch {}
        this.holding = true;
        this.hovered = false;
        this.visible = true;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          try { sessionStorage.setItem('lucent-offers-paused', String(this.userPaused)); } catch {}
          this.sync();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('pointerdown', () => { this.touching = true; this.sync(); }, options);
        document.addEventListener('pointerup', () => { this.touching = false; this.sync(); }, options);
        document.addEventListener('pointercancel', () => { this.touching = false; this.sync(); }, options);
        this.addEventListener('focusin', () => this.sync(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => { if (this.isConnected) this.sync(); }), options);
        this.offers.addEventListener('toggle', () => this.sync(), options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.offers.open) { this.offers.open = false; this.offers.querySelector('summary').focus(); }
        }, options);
        document.addEventListener('click', event => { if (!this.contains(event.target)) this.offers.open = false; }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.reduced.addEventListener('change', () => this.build(), options);
        this.mobile.addEventListener('change', () => this.build(), options);
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.viewport);
        this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.intersectionObserver.observe(this);
        this.build();
        document.fonts.ready.then(() => { if (this.isConnected) this.build(); });
        this.startTimer = setTimeout(() => { this.holding = false; this.sync(); }, 2500);
      }
      build() {
        this.animation?.cancel();
        this.animation = null;
        this.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
        const isStatic = this.reduced.matches || this.dataset.motion === 'false';
        this.toggleAttribute('data-static', isStatic);
        this.setAttribute('data-ready', '');
        this.button.hidden = isStatic || this.group.children.length === 0;
        if (isStatic || !this.group.children.length) return;
        const width = this.group.getBoundingClientRect().width;
        if (!width) return;
        const copies = Math.max(1, Math.ceil(this.viewport.clientWidth / width));
        for (let i = 0; i < copies; i++) {
          const copy = this.group.cloneNode(true);
          copy.setAttribute('data-copy', '');
          this.track.append(copy);
        }
        const configured = Number(this.mobile.matches ? this.dataset.mobileSpeed : this.dataset.desktopSpeed);
        const speed = Math.min(45, Math.max(15, configured || (this.mobile.matches ? 24 : 30)));
        this.animation = this.track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }], { duration: width / speed * 1000, iterations: Infinity, easing: 'linear' });
        this.sync();
      }
      sync() {
        const paused = this.userPaused || this.holding || this.hovered || this.touching || this.offers.open || this.contains(document.activeElement) || document.hidden || !this.visible;
        if (this.animation) { if (paused) this.animation.pause(); else this.animation.play(); }
        const label = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.setAttribute('aria-label', label);
        this.button.title = label;
        this.button.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.userPaused);
        this.button.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.userPaused);
      }
      disconnectedCallback() {
        this.controller.abort();
        this.resizeObserver.disconnect();
        this.intersectionObserver.disconnect();
        this.animation?.cancel();
        clearTimeout(this.startTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lucent-pair-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucent-pair-pricing')) {
    customElements.define('lucent-pair-pricing', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.root = this.closest('.product-area');
        if (!this.root) return;
        try {
          this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
          this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency: this.dataset.currency, currencyDisplay: 'symbol'
          });
        } catch {
          this.hidden = true;
          return;
        }
        this.abort = new AbortController();
        this.update = () => {
          const options = [...this.root.querySelectorAll('.option-selectors select')].map(select => select.value);
          const id = this.root.querySelector('[name="id"]')?.value || this.dataset.initialVariant;
          const variant = options.length
            ? this.variants.find(item => item.options.length === options.length && item.options.every((value, i) => value === options[i]))
            : this.variants.find(item => String(item.id) === String(id));
          this.renderVariant(variant);
        };
        this.onChange = event => {
          if (event.target.matches('.option-selectors select, [name="id"]')) this.update();
        };
        this.root.addEventListener('change', this.onChange, {signal: this.abort.signal});
        window.addEventListener('pageshow', this.update, {signal: this.abort.signal});
        this.update();
      }
      renderVariant(variant) {
        const valid = variant?.available === true && Number.isSafeInteger(variant.price) && variant.price >= 0;
        const lensPrice = Number(this.dataset.lensPrice);
        const total = valid ? variant.price + lensPrice : NaN;
        this.hidden = !Number.isSafeInteger(total) || !Number.isSafeInteger(lensPrice) || lensPrice < 0;
        this.querySelector('[data-pair-total]').textContent = this.hidden ? '—' : this.money.format(total / 100);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
